import apiPaths from '../api-paths';

export default {
  show() {
    return axios.post(`${ apiPaths.PERSON }/get-boss`);
  },
};
